import { mainApi } from "services/main";
import {
  IngestDocumentsRequest,
  IngestDocumentsResponse,
  ListAtlasDocumentsRequest,
  ListAtlasDocumentsResponse,
  DeleteIngestedDocumentsRequest,
  DeleteIngestedDocumentsResponse,
  AtlasDocumentIngestion,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    ingestDocuments: builder.mutation<
      IngestDocumentsResponse,
      IngestDocumentsRequest
    >({
      query: (request: IngestDocumentsRequest) => ({
        url: "atlas/kb/documents",
        method: "POST",
        body: request,
      }),
      invalidatesTags: ["AtlasDocuments"],
    }),
    listAtlasDocuments: builder.query<
      ListAtlasDocumentsResponse,
      ListAtlasDocumentsRequest
    >({
      async queryFn(request, _queryApi, _extraOptions, fetchWithBQ) {
        const allDocuments: AtlasDocumentIngestion[] = [];
        let nextToken: string | undefined;

        // Fetch all pages
        do {
          const params: Record<string, string> = {};
          if (nextToken) params.nextToken = nextToken;
          if (request.includeApprovalInfo) params.includeApprovalInfo = "true";

          const result = await fetchWithBQ({
            url: `atlas/kb/documents/${request.teamName}`,
            method: "GET",
            params: Object.keys(params).length ? params : undefined,
          });

          if (result.error) {
            return { error: result.error };
          }

          const response = result.data as ListAtlasDocumentsResponse;
          allDocuments.push(...(response.documents || []));
          nextToken = response.nextToken;
        } while (nextToken);

        return {
          data: {
            teamName: request.teamName,
            documents: allDocuments,
          },
        };
      },
      providesTags: ["AtlasDocuments"],
    }),
    deleteIngestedDocuments: builder.mutation<
      DeleteIngestedDocumentsResponse,
      DeleteIngestedDocumentsRequest
    >({
      query: (request: DeleteIngestedDocumentsRequest) => ({
        url: "atlas/kb/documents/delete",
        method: "POST",
        body: request,
      }),
      invalidatesTags: ["AtlasDocuments"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useIngestDocumentsMutation,
  useListAtlasDocumentsQuery,
  useDeleteIngestedDocumentsMutation,
} = extendedApi;
